//const words = require('../words.json')
//const get_char_list = () => Array.from(new Set(Array.from(words.reduce((a,b) => (b[0]+b[1]+a), '')))).sort().join('');
const get_char_list = () => ' !&*,-.0123456789:ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyzé’“”\n'
module.exports = {get_char_list};